(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rf2-home-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Jump link in the opening banner: scrolls to the element named in data-rh-jump (the first product grid).
  // If that element is not on the page the link simply goes where its href points.
  if (window.__rhJumpInit) return;
  window.__rhJumpInit = true;

  document.addEventListener('click', function (e) {
    // Leave new-tab and new-window clicks alone: they should follow the link as normal.
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest ? e.target.closest('[data-rh-jump]') : null;
    if (!link) return;
    var target = null;
    try { target = document.querySelector(link.getAttribute('data-rh-jump')); } catch (err) { target = null; }
    if (!target) return;
    e.preventDefault();
    // Stop with the grid's heading visible below the theme's sticky header.
    var offset = 0;
    [].forEach.call(document.querySelectorAll('[class*=shopify-section-group-header]'), function (el) {
      var pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') offset += el.getBoundingClientRect().height;
    });
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Move keyboard focus with the view, so the next Tab lands in the products.
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset - 8, behavior: calm ? 'auto' : 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf2-home-keep"] && !Shopify.designMode) return;
  try {
    
(function () {
  // What do you keep tabs.
  // Everything is handled by listeners on the document, so it keeps working when the theme editor
  // re-renders a section, and each copy of the section only ever switches its own tabs.
  if (window.__rhKeepInit) return;
  window.__rhKeepInit = true;

  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  function select(tab, focus) {
    var section = closest(tab, '[data-rh-keep-section]');
    if (!section) return;
    [].forEach.call(section.querySelectorAll('[role=tab]'), function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    // Bring the chosen tab into view in the tab row. Instant on purpose: a second smooth scroll cancels the page scroll on phones.
    var bar = tab.parentNode;
    if (bar) bar.scrollLeft = Math.max(0, tab.offsetLeft - bar.offsetLeft - 20);
    if (focus) tab.focus({ preventScroll: true });
  }

  function scrollToSection(section) {
    // Stop with the heading visible below the theme's sticky header.
    var offset = 0;
    [].forEach.call(document.querySelectorAll('[class*=shopify-section-group-header]'), function (el) {
      var pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') offset += el.getBoundingClientRect().height;
    });
    var target = section.firstElementChild || section;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset - 16, behavior: calm ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var tab = closest(e.target, '[data-rh-keep-section] [role=tab]');
    if (tab) { select(tab); return; }
    // Chooser buttons in the opening banner open tab N of the first What do you keep section.
    var chip = closest(e.target, '[data-rh-keep]');
    if (!chip) return;
    var section = document.querySelector('[data-rh-keep-section]');
    if (!section) return;
    var target = section.querySelector('[role=tab][data-rh-index="' + chip.getAttribute('data-rh-keep') + '"]');
    if (!target) return;
    select(target, true);
    scrollToSection(section);
  });

  document.addEventListener('keydown', function (e) {
    var tab = closest(e.target, '[data-rh-keep-section] [role=tab]');
    if (!tab) return;
    var tabs = [].slice.call(closest(tab, '[data-rh-keep-section]').querySelectorAll('[role=tab]'));
    var i = tabs.indexOf(tab);
    var next = null;
    if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
    else if (e.key === 'ArrowLeft') next = tabs[(i + tabs.length - 1) % tabs.length];
    else if (e.key === 'Home') next = tabs[0];
    else if (e.key === 'End') next = tabs[tabs.length - 1];
    if (!next) return;
    e.preventDefault();
    select(next, true);
  });

  // Theme editor: clicking a Tab block in the sidebar shows that tab on the page.
  document.addEventListener('shopify:block:select', function (e) {
    var tab = closest(e.target, '[data-rh-keep-section] [role=tab]');
    if (tab) select(tab);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf2-home-trust"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Next dispatch line. Dispatch days are Monday, Tuesday and Thursday; cutoff is 12 noon UK time.
  // Dates listed in the section setting (bank holidays, closures) are skipped.
  // The date is always named, so 'Thursday' can never be read as the wrong Thursday.
  // Same-day wording says 'usually', not 'will': on a busy day an order can go on the next dispatch day.
  // If nothing can be worked out, the text typed in the theme editor is shown instead.
  if (window.__rhDispatchInit) return;
  window.__rhDispatchInit = true;

  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DISPATCH = { 1: true, 2: true, 4: true };
  var HORIZON_DAYS = 120;

  function londonNow() {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
    if (!p.year || !p.month || !p.day || isNaN(p.hour)) return null;
    return p;
  }

  function label(el) {
    var p = londonNow();
    if (!p) return null;
    var closed = (el.getAttribute('data-rh-closed') || '').split(/[\s,]+/);
    var base = Date.UTC(p.year, p.month - 1, p.day);
    for (var n = 0; n <= HORIZON_DAYS; n++) {
      var d = new Date(base + n * 86400000);
      var dow = d.getUTCDay();
      if (!DISPATCH[dow] || closed.indexOf(d.toISOString().slice(0, 10)) !== -1) continue;
      if (n === 0 && p.hour >= 12) continue;
      if (n === 0) return 'Order before 12 noon: usually dispatched today';
      var date = DAYS[dow] + ' ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()];
      return 'Next dispatch: ' + (n === 1 ? 'tomorrow, ' : '') + date;
    }
    return null;
  }

  function update(el) {
    if (!el.hasAttribute('data-rh-typed')) el.setAttribute('data-rh-typed', el.textContent);
    var text = null;
    try { text = label(el); } catch (e) { text = null; }
    if (text === null) text = el.getAttribute('data-rh-typed');
    if (el.textContent !== text) el.textContent = text;
  }

  function updateAll() {
    [].forEach.call(document.querySelectorAll('[data-rh-dispatch]'), update);
  }

  updateAll();
  // Keep it right on a page left open past noon or midnight, and when a sleeping tab wakes up.
  setInterval(updateAll, 60000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) updateAll(); });
  window.addEventListener('pageshow', updateAll);
  // Theme editor: the section is re-rendered without a page reload.
  document.addEventListener('shopify:section:load', updateAll);
})();

  } catch(e) { console.error(e); }
})();
})();
